"use strict";

var _ = require("../../utils/mindash");

module.exports = {
  getItem: _.noop,
  setItem: _.noop
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/stateSource/inbuilt/noopStorage.js
 ** module id = 496
 ** module chunks = 0
 **/